export default "__VITE_ASSET__7hdOyWX___"